export default {
  'pages.myApps.title': '我的應用',
  'pages.myApps.description': '查看目前企業已開通的業務應用，開始團隊工作。',
  'pages.myApps.backToCenter': '返回應用',
  'pages.myApps.refresh': '重新整理',
  'pages.myApps.browseMarket': '瀏覽應用市場',
  'pages.myApps.overview': '應用概覽',
  'pages.myApps.enabledCount': '已開通應用',
  'pages.myApps.availableCount': '可開啟應用',
  'pages.myApps.unconfiguredCount': '未設定存取網址',
  'pages.myApps.currentPackage': '目前方案',
  'pages.myApps.packageError': '方案資訊暫時無法載入。',
  'pages.myApps.retry': '重新載入',
  'pages.myApps.subscription.active': '生效中',
  'pages.myApps.subscription.expired': '已到期',
  'pages.myApps.subscription.suspended': '已暫停',
  'pages.myApps.subscription.cancelled': '已取消',
  'pages.myApps.subscription.unknown': '狀態待確認',
  'pages.myApps.startsAt': '生效日期',
  'pages.myApps.expiresAt': '到期日期',
  'pages.myApps.noExpiry': '長期有效',
  'pages.myApps.dateUnknown': '暫無日期',
  'pages.myApps.noPackage': '暫無目前方案，已開通的應用可繼續使用。',
  'pages.myApps.appList': '已開通應用',
  'pages.myApps.accessDescription':
    '應用將在新視窗開啟；未設定存取網址的應用暫時無法開啟。',
  'pages.myApps.searchLabel': '搜尋應用',
  'pages.myApps.searchPlaceholder': '搜尋應用名稱或 ID',
  'pages.myApps.filterLabel': '依開通來源篩選',
  'pages.myApps.source.all': '全部應用',
  'pages.myApps.source.package': '方案開通',
  'pages.myApps.source.tenant': '個別開通',
  'pages.myApps.source.other': '其他來源',
  'pages.myApps.resultCount': '找到 {count} 個應用',
  'pages.myApps.loadError': '應用清單暫時無法載入',
  'pages.myApps.loadErrorDescription': '請重新載入。目前開通紀錄不會受到影響。',
  'pages.myApps.emptyTitle': '尚未開通應用',
  'pages.myApps.emptyDescription':
    '瀏覽應用市場，探索適合企業與團隊的業務工具。',
  'pages.myApps.noResults': '沒有符合的應用',
  'pages.myApps.noResultsDescription':
    '嘗試其他應用名稱或 ID，或清除搜尋與來源篩選。',
  'pages.myApps.clearFilters': '清除篩選',
  'pages.myApps.available': '可開啟',
  'pages.myApps.unconfigured': '未設定存取網址',
  'pages.myApps.openApp': '開啟應用',
  'pages.myApps.openAppAccessible': '開啟 {name}（新視窗）',
  'pages.myApps.newWindow': '新視窗',
  'pages.myApps.accessUnavailable': '暫時無法開啟',
  'pages.myApps.paginationTotal': '共 {total} 個應用',
};
